import { PersonalInformationReadOnlyFields } from '@exam-center/blocked-user-management';
import { PaperSection } from '@shared/components';

import { useBlockedUserDetails } from '../../providers';

export default function BlockedUserReadonlySection() {
  const { blockedUserDetails } = useBlockedUserDetails();

  return (
    <PaperSection title='ข้อมูลส่วนตัว'>
      <PersonalInformationReadOnlyFields
        idNumber={blockedUserDetails.idNumber}
        title={blockedUserDetails.title}
        firstName={blockedUserDetails.firstName}
        middleName={blockedUserDetails.middleName}
        lastName={blockedUserDetails.lastName}
        email={blockedUserDetails.email}
        phoneNumber={blockedUserDetails.phoneNumber}
      />
    </PaperSection>
  );
}
